import React, { useState } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from "./components/Layout";

import Home from "./pages/Home";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import Profile from './components/Profile';
import {UserContextProvider} from "./contexts/UserContext";
import AuthRequired from "./components/AuthRequired"
import { PostProvider } from "./contexts/PostContext";
import { DBPostsProvider } from './contexts/DBPostsContext';
import Contact from "./pages/Contact";
import About from "./pages/About";
import Services from "./pages/Services";
import Blog from "./pages/Blog";

import CreatePost from "./pages/CreatePost";

import PreviewPost from "./components/PreviewPost";
import TextEditor from "./components/TextEditor";

import PostPage from "./pages/PostPage";
import EditPost from "./pages/EditPost";

function App() {
  return (
    <div className="app">
       <UserContextProvider>
       <DBPostsProvider>
       <PostProvider>
       <Router>
       <Routes>
  <Route path="/" element={<Layout />}>
    <Route index element={<Home />} />
    <Route path="login" element={<LoginPage />} />
    <Route path="register" element={<RegisterPage />} />
    <Route path="profile" element={<Profile />} />
    <Route path="contact" element={<Contact />} />
    <Route path="about" element={<About />} />
    <Route path="services" element={<Services />} />
    <Route path="blog" element={<Blog />} />
    <Route path="blog/post/:id" element={<PostPage />} />  {/* Moved outside Blog */}
    <Route element={<AuthRequired />}>
    <Route path="/blog/create-post" element={<CreatePost />} />
    <Route path="/blog/preview-post" element={<PreviewPost />} />
    <Route path="blog/edit/:id" element={<EditPost />} />
    </Route>
   
    <Route path="text-editor" element={<TextEditor />} />
  </Route>
</Routes>

      </Router>
      </PostProvider>
      </DBPostsProvider>
      </UserContextProvider>
     
    </div>
  );
}

export default App;
